<template>
  <div class="imgsort-list">
    <div class="page-filter">
      <div class="condition-wrap">
        <span class="condition-label">生产者名字</span>
        <el-input class="w200" style="width:200px;" v-model="authorName" placeholder="请输入生产者名字"></el-input>
      </div>
      <div class="condition-wrap">
        <el-button type="primary" @click="search">筛选</el-button>
      </div>
      <div class="condition-wrap">
        <el-button type="success" @click="btnAdd">新增生产者</el-button>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" size="middle" border stripe>
        <el-table-column
        type="index"
        label="序号"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column  prop="authorName" label="生产者名称" align="center"></el-table-column>
      <el-table-column label="国家" align="center">
        <template slot-scope="scope">{{countryObj[scope.row.countryType]}}</template>
      </el-table-column>
      <el-table-column prop="designCount" label="IP数" align="center">
        <template slot-scope="scope">{{scope.row.designCount || 0}}</template>
      </el-table-column>
      <el-table-column prop="designCount" label="状态" align="center">
        <template slot-scope="scope">{{scope.row.status ? '已启用': '已禁用'}}</template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="primary" @click="updateAuthor(scope.row)">修改</el-button>
          <el-button :type="scope.row.status ? 'danger' : 'primary'" @click="upOrDown(scope.row)">{{scope.row.status ? '禁用' : '启用'}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="site-page">
      <el-pagination
        background
        :page-count="totalPage"
        :current-page="pageNum"
        @current-change="currentChange"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <el-dialog @close="diaglogClose" :close-on-click-modal="false" :title="isEdit ? '编辑生产者' : '新增生产者'" :visible.sync="showAddPop" width="500px">
      <el-form :model="addForm" size="small" label-width="100px">
        <el-form-item label="生产者">
          <el-input v-model="addForm.authorName" placeholder="请输入生产者"></el-input>
        </el-form-item>
        <!-- <el-form-item label="生产者英文名">
          <el-input v-model="addForm.realNameEn" placeholder="请输入生产者英文名"></el-input>
        </el-form-item> -->
        <el-form-item label="移动电话">
          <el-input v-model="addForm.telephone" placeholder="请输入移动电话"></el-input>
        </el-form-item>
        <el-form-item label="国家">
          <el-select  v-model="addForm.countryType">
            <div v-for="item in countryList" :key="item.value">
              <el-option :label="item.name" :value="item.value"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="国籍" placeholder="请选择国籍">
          <el-select  v-model="addForm.nationality">
            <div v-for="item in countryAllList" :key="item.code">
              <el-option :label="item.name" :value="item.code"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="画派" placeholder="请选择画派">
          <el-select multiple collapse-tags v-model="addForm.paintIds">
            <div v-for="item in paintList" :key="item.code">
              <el-option :label="item.name" :value="item.code"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="推荐" placeholder="请选择推荐">
          <el-select multiple collapse-tags v-model="addForm.recommendTagIds">
            <div v-for="item in recommendList" :key="item.code">
              <el-option :label="item.name" :value="item.code"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <template>
            <el-radio v-model="addForm.authorType" label="1">个人</el-radio>
            <el-radio v-model="addForm.authorType" label="2">公司</el-radio>
            <el-input v-model="addForm.authorInfo" :disabled="addForm.authorType == '1'" placeholder="请输入所属公司"></el-input>
          </template>
        </el-form-item>
        <el-form-item label="分成比例">
          <template>
            <el-input
              placeholder="请输入分成比例"
              type="number"
              v-model="addForm.percentage">
              <template slot="append">%</template>
            </el-input>
          </template>
        </el-form-item>
        <el-form-item label="介绍">
          <el-input
            type="textarea"
            :rows="3"
            maxlength="100"
            placeholder="请输入生产者介绍"
            show-word-limit
            v-model="addForm.remark">
          </el-input>
        </el-form-item>
        <el-form-item label="生产者照片">
          <el-upload
            class="upload-demo"
            :action="ossUrl"
            :data="addForm.ossDataImg"
            :limit="1"
            :on-success="uploaded"
            :on-change="uploadCg"
            list-type="picture"
            :file-list="addForm.authorPicList"
            accept="image/jpeg,image/png"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">仅支持jpeg或者png，小于20M</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="文档介绍">
          <el-upload
            class="upload-demo"
            :action="ossUrl"
            :data="addForm.ossDataVedio"
            :limit="1"
            :on-success="uploadedWorks"
            :on-change="uploadCgWorks"
            :file-list="addForm.vedioSourceList"
            accept="application/pdf" 
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">仅支持PDF, 小于20M</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center;">
        <el-button @click="showAddPop = false">取 消</el-button>
        <el-button type="primary" @click="addAuthor">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>


<script>
import API from "../lib/API";
import {countryList} from '../lib/constObj.js'
export default {
  name: "OrderList",
  data() {
    return {
      tableData: [],
      pageNum: 1,
      totalPage: 0,
      showAddPop: false,
      ossUrl: "",
      authorName: '',
      ossData: {},
      isEdit: false,
      addForm: {
        countryType: "2",
        nationality: '',
        paintIds: [],
        recommendTagIds: [],
        authorPic: "",
        authorType: '1',
        authorInfo: '',
        telephone: '',
        vedioSource: '',
        ossDataImg: {},
        ossDataVedio: {},
        remark: '',
        authorName: '',
        realNameEn: '',
        percentage: 50,
        status: 1,
        authorPicList: [],
        vedioSourceList: []
      },
      // 数据类型列表
      countryList: [],
      countryObj: {},
      countryAllList: [],
      paintList: [],
      recommendList: []
    };
  },
  methods: {
    btnAdd() {
      this.isEdit = false
      this.showAddPop = true;
      this.ossUrl = "";
      this.ossData = {};
      this.getOss();
    },
    getOss() {
      new API(this).POST({
        url: "/oss/getSignature",
        params: {
          count: 1,
          type: 5
        },
        cb: res => {
          this.ossUrl = res.url;
          this.ossData = JSON.parse(JSON.stringify(res.signatures[0]));
          this.addForm.ossDataImg = JSON.parse(JSON.stringify(res.signatures[0]));
          this.addForm.ossDataVedio = JSON.parse(JSON.stringify(res.signatures[0]));
        }
      });
    },
    upOrDown({status, authorId}) {
      new API(this).POST({
        url: `/author/changeStatus`,
        params: {
          status: status ? 0 : 1,
          authorId
        },
        cb: res => {
          this.$message.success('操作成功')
          this.getAuthorList()
        }
      });
    },
    updateAuthor(row) {
      this.btnAdd()
      this.isEdit = true
      new API(this).POST({
        url: `/author/getAuthorDetail?authorId=${row.authorId}`,
        cb: res => {
          Object.assign(this.addForm, res)
          if (res.authorPic) {
            this.addForm.authorPicList = [{name:this.getFileName(res.authorPic), url: res.authorPicUrl }] 
          } else {
            this.addForm.authorPicList = []
          }
          if (res.vedioSource) {
            this.addForm.vedioSourceList = [{name:this.getFileName(res.vedioSource), url: res.vedioSourceUrl }] 
          } else {
            this.addForm.vedioSourceList = []
          }
        }
      });
    },
    getFileName (str) {
      return str.split('/').pop()
    },
    currentChange(val) {
      this.pageNum = val;
      this.getAuthorList();
    },
    search() {
      this.pageNum = 1
      this.getAuthorList()
    },
    getAuthorList() {
      new API(this).POST({
        url: "/author/listWithPage",
        params: {
          count: true,
          pageNum: this.pageNum,
          pageSize: 10,
          authorName: this.authorName,
        },
        cb: res => {
          let { pages, result } = res;

          this.totalPage = pages;
          this.tableData = result;
        }
      });
    },
    addAuthor() {
      let {authorType, authorPic, telephone, vedioSource, remark, percentage, authorName, authorInfo, nationality, paintIds, realNameEn, recommendTagIds } = this.addForm;
      if(!authorName) {
        this.$message.error("请填写生产者名称~");
        return;
      }
      // if(!realNameEn) {
      //   this.$message.error("请填写生产者英文名~");
      //   return;
      // }
      if(!nationality) {
        this.$message.error("请填写国籍~");
        return;
      }
      if(!paintIds.length) {
        this.$message.error("请填写画派~");
        return;
      }
      if(!recommendTagIds.length) {
        this.$message.error("请填写推荐~");
        return;
      }
      if(!telephone || !/^1\d{10}$/.test(telephone)) {
        this.$message.error("请填写正确的移动电话~");
        return;
      }
      if(authorType == '2' && !authorInfo) {
        this.$message.error("请填写公司~");
        return;
      }
      if(percentage === '') {
        this.$message.error("请填写分成比例~");
         return;
      }
      if(percentage > 100 || percentage < 0) {
         this.$message.error("分成比例在0-100之间~");
         return;
      }
      let url = this.isEdit ? '/author/updateAuthor' : '/author/addAuthor'
      new API(this).POST({
        url,
        params: this.addForm,
        cb: res => {
          if (res === null) {
            this.$message.success('操作成功')
            this.getAuthorList();
            this.showAddPop = false;
          }
        }
      });
    },
    diaglogClose() {
      this.addForm = {
        countryType: "2",
        nationality: '',
        paintIds: [],
        recommendTagIds: [],
        authorPic: "",
        authorType: '1',
        authorInfo: '',
        telephone: '',
        vedioSource: '',
        ossDataImg: {},
        ossDataVedio: {},
        remark: '',
        authorName: '',
        realNameEn: '',
        percentage: 50,
        status: 1,
        authorPicList: [],
        vedioSourceList: []
      }
    },
    uploaded(val) {
      this.addForm.authorPic = this.addForm.ossDataImg.key;
    },
    getCountryList() {
      new API(this).POST({
        url: "/select/findCountryList",
        cb: res => {
          this.countryAllList= res;
        }
      });
    },
    getPaintList() {
      new API(this).POST({
        url: "/select/findPaintList",
        cb: res => {
          this.paintList= res;
        }
      });
    },
    getRecommendList() {
      new API(this).POST({
        url: "/select/findRecommendTagList",
        cb: res => {
          this.recommendList= res;
        }
      });
    },
    uploadedWorks(val) {
      this.addForm.vedioSource = this.addForm.ossDataVedio.key;
    },
    uploadCg(file) {
      this.uploadCgDeal(file, 'ossDataImg')
    },
    uploadCgWorks (file) {
      this.uploadCgDeal(file, 'ossDataVedio')
    },
    uploadCgDeal(file, attr) {
      let ext = file.raw.type;
      ext = ext ? "." + ext.split("/")[1] : "";
      let hasExt = this.ossData.key.indexOf(".");
      if (hasExt === -1) {
        this.addForm[attr]['key'] = this.ossData.key + ext;
      } else {
        this.addForm[attr]['key'] = this.ossData.key.slice(0, hasExt);
        this.addForm[attr]['key'] += ext;
      }
    },
    dealObj () {
      this.countryList.forEach(item => {
        this.countryObj[item.value] = item.name
      })

    }
  },
  created() {
    this.countryList = countryList.slice(1)
    this.dealObj()
    this.getCountryList()
    this.getPaintList()
    this.getAuthorList()
    this.getRecommendList()
  }
};
</script>


// WEBPACK FOOTER //
// src/components/AuthorManage.vue